export default __webpack_public_path__ + "static/media/bg_outline.e1f265b1.png";